import { ReactNode } from 'react';

interface PageLayoutType {
  children: ReactNode;
}

export const PageLayout = (props: PageLayoutType) => {
  return (
    <div className='min-h-screen flex flex-col '>
      <main className='flex-grow bg-[#f7f8f9] pb-[103px] bgImage'>{props.children}</main>
    </div>
  );
};
